import { propEq } from 'ramda'
import React from 'react'

import { ACTIONS } from '../_constants/actions'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { useWebhook } from './_load/WebhookLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TabsMenu from '../../../packages/kiti/components/tabs/TabsMenu'

const ModalHeader = () => {
  const webhook = useWebhook()

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <SmallText size="xsmall">{ACTIONS.find(propEq('id', webhook.action))?.name}</SmallText>
          <Title size="h5" bold>
            {webhook.name}
          </Title>
        </Col>
      </Grid>

      <Separator weight={2} />

      <TabsMenu />
    </>
  )
}

export default ModalHeader
